export enum AirwaySeatLocation {
  WINDOW = "Window",
  AISLE = "Aisle",
}

export type AirwaySeatStretch = {
  id: string;
  arrivalDate: Date;
  departure: string;
  arrival: string;
  flightNumber: string;
  mapSeats: {
    class: string;
    purchaseOfSeats: boolean;
    blueSpace: boolean;
    rowns: {
      row: number;
      isWing: boolean;
      available: boolean;
      startWing: boolean;
      emergencyExit: boolean;
      endWing: boolean;
      columns: {
        column: string;
        busy: boolean;
        location: AirwaySeatLocation;
        situation: string;
        value: number;
        seatTypeDescription: string;
      }[];
    }[];
  }[];
};

export type AirwaySeats = {
  searchKey: string;
  data: AirwaySeatStretch[];
  byPassenger?: {
    customerEmployeeUuid: string;
    stretches: AirwaySeatStretch[];
  }[];
};

export type AirwaySeatsForm = {
  search_key: string;
  seats: {
    column: string;
    row: string;
    customer_employee_uuid: string;
    stretch_id: string;
    canonical_stretch_id?: string;
    value: number;
    selected: boolean;
  }[];
};

export type AirwaySeatMarkLink = {
  waitTime: number;
  link: string;
};
